import axios from 'axios'
import i18n from '../plugins/i18n'

export default {
  developerStatistics(filters) {
    let filter = ''

    for (const field in filters) {
      filter += `${encodeURIComponent(field)}=${encodeURIComponent(filters[field])}&`
    }
    return axios.get(`${i18n.locale}/api/public/portalStatistics/developerStatistics?${filter}`)
  },
  categoryStatistics(filters) {
    let filter = ''

    for (const field in filters) {
      filter += `${encodeURIComponent(field)}=${encodeURIComponent(filters[field])}&`
    }
    return axios.get(`${i18n.locale}/api/public/portalStatistics/categoryStatistics?${filter}`)
  }
}
